<template>
  <div>
    <a-input
      v-model="searchText"
      placeholder="Tìm kiếm..."
      style="width: 260px; margin-bottom: 10px"
    />

    <a-table
      rowKey="id"
      size="small"
      bordered
      :columns="columns"
      :data-source="lstShow"
    />
  </div>
</template>

<script>
export default {
  name: "RewardPage",

  data() {
    return {
      searchText: "",

      lstData: [
        {
          "id": "1",
          "Province": "Sông Tiền",
          "Company": "Hộ kinh doanh Lê Thế Vinh",
          "Address": "số 71, đường Trần Đại Nghĩa, phường Phước Hậu, tỉnh Vĩnh Long"
        },
        {
          "id": "2",
          "Province": "Sông Tiền",
          "Company": "Đại lý chị Thảo",
          "Address": "Ấp Phú Long A, Xã Phú Quới, Tỉnh Vĩnh Long, Việt Nam"
        },
        {
          "id": "3",
          "Province": "Sông Tiền",
          "Company": "Như Mức",
          "Address": "ấp Mỹ An, phường Cái Vồn, tỉnh Vĩnh Long"
        },
        {
          "id": "4",
          "Province": "Sông Tiền",
          "Company": "Cẩm Hường",
          "Address": "ấp Đông Thạnh A, phường Đông Thành, tỉnh Vĩnh Long"
        },
        {
          "id": "5",
          "Province": "Sông Tiền",
          "Company": "Đại Lý Thành Công",
          "Address": "Ấp Phước Lộc Thọ, Xã Bình Phước, Tỉnh Vĩnh Long"
        },
        {
          "id": "6",
          "Province": "Sông Tiền",
          "Company": "ĐẠI LÝ BIA TÂN NGÂN",
          "Address": "Ấp Phú An 1, Xã An Bình, Tỉnh Vĩnh Long"
        },
        {
          "id": "7",
          "Province": "Sông Tiền",
          "Company": "Thanh Trúc",
          "Address": "Tổ 5, ấp 3, Xã Hòa Hiệp, Vĩnh Long"
        },
        {
          "id": "8",
          "Province": "Sông Tiền",
          "Company": "CÔNG TY TNHH LÊ HIỆP SA ĐÉC",
          "Address": "Số 40, QL80 , khóm Hòa An, Phường Sa Đéc, tỉnh Đồng Tháp."
        },
        {
          "id": "9",
          "Province": "Sông Tiền",
          "Company": "Đại Lý Thùy Trang ( Chính)",
          "Address": "Nguyễn Văn Voi, xã Phú Hựu, Đồng Tháp"
        },
        {
          "id": "10",
          "Province": "Sông Tiền",
          "Company": "HỘ KINH DOANH TẠP HÓA GẤM TÍ (TÍ VÀM LÁNG)",
          "Address": "Số 255, Ấp Tân Xuân, Xã Tân Hòa, Tỉnh Đồng Tháp"
        },
        {
          "id": "11",
          "Province": "Sông Tiền",
          "Company": "VÕ TUẤN HẢI (HẢI MẬP)",
          "Address": "Số 12, Ấp Hiệp Trị - Xã Bình Nghị, Xã Tân Hòa, Đồng Tháp"
        },
        {
          "id": "12",
          "Province": "Sông Tiền",
          "Company": "HỘ KINH DOANH BIA - NƯỚC NGỌT MẠNH THẮNG",
          "Address": "193 Nguyễn Trung Trực, Khu phố Mỹ Thạnh, Phường Mỹ Phong, Đồng Tháp"
        },
        {
          "id": "13",
          "Province": "Sông Tiền",
          "Company": "CÔNG TY TNHH THƯƠNG MẠI NGÔ THANH TÂM",
          "Address": "Tỉnh lộ 879, Phường Mỹ Phong , Tỉnh Đòng Tháp"
        },
        {
          "id": "14",
          "Province": "Sông Tiền",
          "Company": "Anh Thiện",
          "Address": "An Thiện, Xã Hội Cư, Tỉnh Đồng Tháp, Việt Nam"
        },
        {
          "id": "15",
          "Province": "Sông Tiền",
          "Company": "Quốc Hùng",
          "Address": "Ấp Hậu Hoa, Xã Hội Cư, Tỉnh Đồng Tháp, Việt Nam"
        },
        {
          "id": "16",
          "Province": "Sông Tiền",
          "Company": "Phan Ngọc Giàu",
          "Address": "239 Đường Võ Việt Tân,Kp1,Phường Cai Lậy, Tỉnh Đồng Tháp"
        },
        {
          "id": "17",
          "Province": "Sông Tiền",
          "Company": "Đại lý bia - nước ngọt Hữu Khang",
          "Address": "Ấp Đon, xã Nhị Long, Vĩnh Long"
        },
        {
          "id": "18",
          "Province": "Sông Tiền",
          "Company": "Thầy Thượng",
          "Address": "Ấp La Bang Chợ, xã Đôn Châu, tỉnh Vĩnh Long"
        },
        {
          "id": "19",
          "Province": "Sông Tiền",
          "Company": "Anh Toàn ",
          "Address": "Ấp Đại Mong, Xã Tiểu Cần, Tỉnh Vĩnh Long"
        },
        {
          "id": "20",
          "Province": "Sông Tiền",
          "Company": "Minh Thiện Trà Vinh ",
          "Address": "Khóm 1, Phường Trà Vinh, Tỉnh Vĩnh Long"
        },
        {
          "id": "21",
          "Province": "Sông Tiền",
          "Company": "CÔNG TY TNHH MỘT THÀNH VIÊN THÁI HÒA TV",
          "Address": "Ấp 5, Xã Trà Cú, Tỉnh Vĩnh Long"
        },
        {
          "id": "22",
          "Province": "Sông Tiền",
          "Company": "Sẻ Nhỏ",
          "Address": "khóm 4, phường Duyên Hải, tỉnh Vĩnh Long"
        },
        {
          "id": "23",
          "Province": "Sông Tiền",
          "Company": "Lập Nghiệp",
          "Address": "Số 126, ấp I, Xã An Long, Đồng Tháp"
        },
        {
          "id": "24",
          "Province": "Sông Tiền",
          "Company": "CÔNG TY TNHH THƯƠNG MẠI TỔNG HỢP ANH HUÂN THÁP MƯỜI",
          "Address": "Ấp Mỹ An 1, Xã Tháp Mười, tỉnh Đồng Tháp, Việt Nam"
        },
        {
          "id": "25",
          "Province": "Sông Tiền",
          "Company": "CÔNG TY TNHH\n TRẦN THỊ NHƯ THỦY",
          "Address": "Số 474, Tổ 20, Ấp 3, Xã Bình Hàng Trung, Tỉnh Đồng Tháp, Việt Nam"
        },
        {
          "id": "26",
          "Province": "Sông Tiền",
          "Company": "HỘ KINH DOANH PHAN MINH CẢNH",
          "Address": "khóm An Thạnh A, Phường An Bình, Đồng Tháp"
        },
        {
          "id": "27",
          "Province": "Sông Tiền",
          "Company": "Chị Trang",
          "Address": "Ấp Phú Lâm, Xã An Hòa, Tỉnh Đồng Tháp"
        },
        {
          "id": "28",
          "Province": "Sông Tiền",
          "Company": "Đại Lý Bia Nước Ngọt Ngọc Ẩn",
          "Address": "Sô 115,Ấp 4,Phường Tân An,Tỉnh Tây Ninh,Việt Nam"
        },
        {
          "id": "29",
          "Province": "Sông Tiền",
          "Company": "Hộ Kinh Doanh Chín Điệp",
          "Address": "227, Ấp Cầu Tre, Phường Khánh Hậu, Tỉnh Tây Ninh, Việt Nam"
        },
        {
          "id": "30",
          "Province": "Sông Tiền",
          "Company": "Nguyễn Văn Quí (Gia Huy)",
          "Address": "Số 366,Ấp Bình Hòa,Xã Tân Trụ,Tỉnh Tây Ninh,Việt Nam"
        },
        {
          "id": "31",
          "Province": "Sông Tiền",
          "Company": "Hằng Kê 68",
          "Address": "137,Quốc Lộ 62, khu phố 1,Phường Kiến Tường,Tỉnh Tây Ninh,Việt Nam"
        },
        {
          "id": "32",
          "Province": "Sông Tiền",
          "Company": "Hkd Phạm Nguyễn Hoàng Sơn",
          "Address": "71, Đường Nguyễn Văn Tuôi, Xã Bến Lức, Tỉnh Tây Ninh, Việt Nam"
        },
        {
          "id": "33",
          "Province": "Sông Tiền",
          "Company": "A Điều 1",
          "Address": "Số 2016, đường 24a, ấp Bình tiền 1, Xã Đức Hòa, Tỉnh Tây Ninh, Việt Nam"
        },
        {
          "id": "34",
          "Province": "Sông Tiền",
          "Company": "Bin Bin(Khánh Quân)",
          "Address": "Ấp Bình Tiền 1, xã Đức Hoà, tỉnh Tây Ninh"
        },
        {
          "id": "35",
          "Province": "Sông Tiền",
          "Company": "CÔNG TY TNHH BÁCH HÓA VÀ VẬN CHUYỂN TUẤN HÒA",
          "Address": "Số 568/29, Tổ 24, Ấp Vĩnh Hưng 1, Xã Vĩnh Thành, Tỉnh Vĩnh Long"
        },
        {
          "id": "36",
          "Province": "Sông Tiền",
          "Company": "HỘ KINH DOANH LÊ VĂN THẢO",
          "Address": "207, Ấp Thanh Sơn 4, Phường Bến Tre, tỉnh Vĩnh Long"
        },
        {
          "id": "37",
          "Province": "Sông Tiền",
          "Company": "Hộ Kinh Doanh Thanh Hoà",
          "Address": "Số 110D, Nguyễn Văn Tư, khu phố 4, Phường Bến Tre, Tỉnh Vĩnh Long, Việt Nam"
        },
        {
          "id": "38",
          "Province": "Sông Tiền",
          "Company": "9 Vũ",
          "Address": "Số 61E, Ấp An Thuận B, Phường An Hội, Tỉnh Vĩnh Long"
        },
        {
          "id": "39",
          "Province": "Sông Tiền",
          "Company": "Lê Thị Thiện Nữ",
          "Address": "Ấp An Thuận A,Phường An Hội,Tỉnh Vĩnh Long"
        },
        {
          "id": "40",
          "Province": "Sông Tiền",
          "Company": "Hộ kinh doanh Nguyễn Thị Đầm",
          "Address": "Số 312C, Ấp Phú Lợi, Phường Bến Tre, Tỉnh Vĩnh Long"
        },
        {
          "id": "41",
          "Province": "Nam Trung Bộ",
          "Company": "DNTN Thái Vân Nha Trang",
          "Address": "52, Phong Châu, Phường Nam Nha Trang, Tỉnh Khánh Hòa"
        },
        {
          "id": "42",
          "Province": "Nam Trung Bộ",
          "Company": "CTY TNHH Nhật Quang Nguyên",
          "Address": "52 Núi Một, Phường Nha Trang, Khánh Hòa"
        },
        {
          "id": "43",
          "Province": "Nam Trung Bộ",
          "Company": "CTY TNHH MTV Thành Việt Nha Trang",
          "Address": "86, Đường 2/4,Phường Nha Trang, Tỉnh Khánh Hòa, Việt Nam"
        },
        {
          "id": "44",
          "Province": "Nam Trung Bộ",
          "Company": "Công ty TNHH TM-DV Thu Thảo",
          "Address": "376, Đường 2/4, Phường Bắc Nha Trang, Tỉnh Khánh Hòa, Việt Nam"
        },
        {
          "id": "45",
          "Province": "Nam Trung Bộ",
          "Company": "Trúc Hỷ",
          "Address": "271, Phước Long, Phường Nam Nha Trang, Tỉnh Khánh Hòa, Việt Nam"
        },
        {
          "id": "46",
          "Province": "Nam Trung Bộ",
          "Company": "Khánh Linh",
          "Address": "44 thích quảng đức.KĐT lê Hồng Phong, Nam Nha Trang, Tỉnh Khánh Hòa"
        },
        {
          "id": "47",
          "Province": "Nam Trung Bộ",
          "Company": "Quỳnh Hương",
          "Address": "Vĩnh Điềm Trung, Tây Nha Trang, Khánh Hòa"
        },
        {
          "id": "48",
          "Province": "Nam Trung Bộ",
          "Company": "TH Bia Lạnh 76",
          "Address": "36 Nguyễn Bặc, Bắc Nha Trang, Tỉnh Khánh Hòa"
        },
        {
          "id": "49",
          "Province": "Nam Trung Bộ",
          "Company": "Gia Phú",
          "Address": "90 Song Hào, Nam Nha Trang, Khánh Hòa"
        },
        {
          "id": "50",
          "Province": "Nam Trung Bộ",
          "Company": "Cát Tường",
          "Address": "Tổ 2, Đảo Trí Nguyên, Phường Nha Trang, Tỉnh Khánh Hòa, Việt Nam Hòa, Việt Nam"
        },
        {
          "id": "51",
          "Province": "Nam Trung Bộ",
          "Company": "Phong Dung",
          "Address": "205 Cầu Dứa Phú Nông, P Tây Nha Trang, Khánh Hòa"
        },
        {
          "id": "52",
          "Province": "Nam Trung Bộ",
          "Company": "Hà",
          "Address": "Đường Lỗ Lầy, Xã Diên Điền, Tỉnh Khánh Hòa"
        },
        {
          "id": "53",
          "Province": "Nam Trung Bộ",
          "Company": "Mai Hương",
          "Address": "Đội 56 Thôn Phú Khánh Trung, Xã Diên Lạc, Khánh Hòa"
        },
        {
          "id": "54",
          "Province": "Nam Trung Bộ",
          "Company": "Đại lý Bia Văn Hoàng",
          "Address": "53 Nguyễn Đức Cảnh, Phường Nam Nha Trang, Tỉnh Khánh Hòa"
        },
        {
          "id": "55",
          "Province": "Nam Trung Bộ",
          "Company": "Công ty TNHH thương mại dịch vụ Gấu Yêu",
          "Address": "Đinh Tiên Hoàng, Xã Cam Lâm, Tỉnh Khánh Hòa, Việt Nam"
        },
        {
          "id": "56",
          "Province": "Nam Trung Bộ",
          "Company": "Thanh Thúy",
          "Address": "Nho Lâm, Xã Phú Hòa 2, ĐăkLắk"
        },
        {
          "id": "57",
          "Province": "Nam Trung Bộ",
          "Company": "Biển Việt",
          "Address": "Phong Niên, Xã Phú Hòa 1, ĐắkLắk"
        },
        {
          "id": "58",
          "Province": "Nam Trung Bộ",
          "Company": "Tám Mẫu",
          "Address": "Khu phố 6, Ninh Tịnh, Phường Tuy Hòa, , Đắk Lắk"
        },
        {
          "id": "59",
          "Province": "Nam Trung Bộ",
          "Company": "DNTN TM Thanh Vũ",
          "Address": "Trần Hưng Đạo, KP2, phường Hòa Vinh, Đắk Lắk"
        },
        {
          "id": "60",
          "Province": "Nam Trung Bộ",
          "Company": "Phê Cương",
          "Address": "Tân Phước, Xã Đồng Xuân, Đắk Lắk"
        },
        {
          "id": "61",
          "Province": "Nam Trung Bộ",
          "Company": "Nhật Duy",
          "Address": "25 Võ Thị Sáu, Sông Cầu, Đắk Lắk"
        },
        {
          "id": "62",
          "Province": "Nam Trung Bộ",
          "Company": "Hà Sen",
          "Address": "Tân Vinh, Xã Đồng Xuân, Đắk Lắk"
        },
        {
          "id": "63",
          "Province": "Nam Trung Bộ",
          "Company": "Kim Yên (Bà Dáng)",
          "Address": "KP6,  Xã Ninh Phước, Tỉnh Khánh Hòa"
        },
        {
          "id": "64",
          "Province": "Nam Trung Bộ",
          "Company": "Kim Chi",
          "Address": "Xã Phước Hậu, Tỉnh Khánh Hòa"
        },
        {
          "id": "65",
          "Province": "Nam Trung Bộ",
          "Company": "Hồng Lài",
          "Address": "Hoài Nhơn, Xã Phước Hậu, Tỉnh Khánh Hòa"
        },
        {
          "id": "66",
          "Province": "Nam Trung Bộ",
          "Company": "Hoa Hiệp",
          "Address": "Phước Thiện 3, Xã Phước Hậu, Tỉnh Khánh Hòa"
        },
        {
          "id": "67",
          "Province": "Nam Trung Bộ",
          "Company": "Trung Loan",
          "Address": "Phương Cựu 3, Xã Ninh Hải, Tỉnh Khánh Hòa"
        },
        {
          "id": "68",
          "Province": "Nam Trung Bộ",
          "Company": "Cty TNHH TM Và DV Trung Trí",
          "Address": "Phương Cựu 3, Xã Ninh Hải, Tỉnh Khánh Hòa"
        },
        {
          "id": "69",
          "Province": "Nam Trung Bộ",
          "Company": "Phương Nguyên",
          "Address": "230 Trường Chinh, Phường Ninh Chữ, Tỉnh Khánh Hòa"
        },
        {
          "id": "70",
          "Province": "Nam Trung Bộ",
          "Company": "Cty TNHH TMDV Đan Đào",
          "Address": "34 Quang Trung, Phường Phan Rang , Tỉnh Khánh Hòa"
        },
        {
          "id": "71",
          "Province": "Nam Trung Bộ",
          "Company": "Quỳnh Nga",
          "Address": "ĐL Hùng Vương, Phường Phú Thủy, Lâm Đồng"
        },
        {
          "id": "72",
          "Province": "Nam Trung Bộ",
          "Company": "Song Mã",
          "Address": "229 Đặng Dung, Phường Bình Thuận, Lâm Đồng"
        },
        {
          "id": "73",
          "Province": "Nam Trung Bộ",
          "Company": "Mười Quân",
          "Address": "Thôn Sùng Nhơn 2, Nam Thành, Lâm Đồng"
        },
        {
          "id": "74",
          "Province": "Nam Trung Bộ",
          "Company": "Liễu Hằng",
          "Address": "Xã Tân Lập, Lâm Đồng"
        },
        {
          "id": "75",
          "Province": "Nam Trung Bộ",
          "Company": "Công Ty TNHH An Hòa Liên Hương ",
          "Address": "167 Trần Phú Xã liên Hương, Lâm Đồng "
        },
        {
          "id": "76",
          "Province": "Nam Trung Bộ",
          "Company": "Công Ty TNHH Một Thành Viên Thương Mại Dịch Vụ Vân Khánh Thịnh",
          "Address": "Thôn Thắng Thuận, P.Hàm Thắng, Lâm Đồng"
        },
        {
          "id": "77",
          "Province": "Nam Trung Bộ",
          "Company": "Hường (Thanh Phú BT)",
          "Address": "76A Nguyễn Văn Cừ, Phường Phan Thiết, Tỉnh Lâm Đồng"
        },
        {
          "id": "78",
          "Province": "Nam Trung Bộ",
          "Company": "Anh Vũ Hàng Me",
          "Address": "Phường Hàm Thắng, Lâm Đồng"
        },
        {
          "id": "79",
          "Province": "Nam Trung Bộ",
          "Company": "Đông Vũ",
          "Address": "Thôn Phú Sơn, Xã Tuyên Quang, Lâm Đồng"
        },
        {
          "id": "80",
          "Province": "Nam Trung Bộ",
          "Company": "Bia Lạnh Ti Lùn",
          "Address": "Khu Phố 12, Phường Mũi Né, Lâm Đồng"
        },
        {
          "id": "81",
          "Province": "Tây Nguyên",
          "Company": "Lê Thị Bích Hợp ( Bích Hợp )",
          "Address": "K1, Xã Krông Pắc, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "82",
          "Province": "Tây Nguyên",
          "Company": "Phạm Hoàng Thủy (Thông Thuỷ)",
          "Address": "170, Lê Duẩn, Phường Buôn Ma Thuột, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "83",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh TH Mình Khôi",
          "Address": "thôn 6, Xã Dray Bhăng, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "84",
          "Province": "Tây Nguyên",
          "Company": "Tấn Lộc",
          "Address": "Thôn Lộc Tân, Xã Krông Năng, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "85",
          "Province": "Tây Nguyên",
          "Company": "Cao Đăng Hoa (Minh Hoa)",
          "Address": "Thôn Sân Bay, Xã Liên Sơn Lắk, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "86",
          "Province": "Tây Nguyên",
          "Company": "CÔNG TY TNHH THƯƠNG MẠI BÉ HÀ GROUP",
          "Address": "Thôn 2, Phường Tân An, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "87",
          "Province": "Tây Nguyên",
          "Company": "Xuân Kiên",
          "Address": "211, Y Moan, Phường Buôn Ma Thuột, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "88",
          "Province": "Tây Nguyên",
          "Company": "Nguyễn Thị Huệ ( TH Huệ Linh)",
          "Address": "72, Nguyễn Văn Linh, Phường Tân An, Tỉnh Đắk Lắk, Việt Nam"
        },
        {
          "id": "89",
          "Province": "Tây Nguyên",
          "Company": "Hoa Lê Mart",
          "Address": "Quang Trung, Phường Bắc Gia Nghĩa, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "90",
          "Province": "Tây Nguyên",
          "Company": "CÔNG TY TNHH MTV THƯƠNG MẠI HÀ PHÁT",
          "Address": "32, Hùng Vương, Xã Cư Jút, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "91",
          "Province": "Tây Nguyên",
          "Company": "Công Ty TNHH Khánh Ngân Phát",
          "Address": "số 10 Nơ Trang Long, Xã Kiến Đức, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "92",
          "Province": "Tây Nguyên",
          "Company": "HỘ KINH DOANH CHÂU LIÊN-Nguyễn Thị DIễm Châu",
          "Address": "TDP 6, Xã Đức Lập, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "93",
          "Province": "Tây Nguyên",
          "Company": "HỘ KINH DOANH TRẦN VĂN NGHỄ",
          "Address": "395 Phạm văn Đồng, tổ 4, Phường Thống Nhất, Gia Lai"
        },
        {
          "id": "94",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh NGUYỄN MINH PHỤNG",
          "Address": "131 Lê Duẩn, phường Pleiku, tỉnh Gia Lai"
        },
        {
          "id": "95",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh Trần Thanh Lương (Tuyến Liêm)",
          "Address": "Tổ dân phố 4, xã Ia Grai, tỉnh Gia Lai"
        },
        {
          "id": "96",
          "Province": "Tây Nguyên",
          "Company": "Hoàng Kim Dũng (Hoàng Dũng)",
          "Address": "171 Wừu, xã Đak Đoa, tỉnh Gia Lai"
        },
        {
          "id": "97",
          "Province": "Tây Nguyên",
          "Company": "Hộ Kinh Doanh Phạm Thị Nga",
          "Address": "29 Trần Nhật Duật, phường Diên Hồng, tỉnh Gia Lai"
        },
        {
          "id": "98",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh BÙI HẢI NINH (Quốc Phương)",
          "Address": "102 Lê Lợi, xã Chư Păh, tỉnh Gia Lai, Việt Nam"
        },
        {
          "id": "99",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh Huỳnh Thị Thanh Thúy (tạp hóa Phượng)",
          "Address": "353A, Trường Chinh, Phường Hội Phú, Tỉnh Gia Lai, Việt Nam"
        },
        {
          "id": "100",
          "Province": "Tây Nguyên",
          "Company": "Hồ Thị Huyền (TH Hải Huyền)",
          "Address": "Số nhà 686 Hùng Vương, xã Chư Sê, tỉnh Gia Lai"
        },
        {
          "id": "101",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh PHAN THỊ THẢO (Tạp hóa Thu Thảo)",
          "Address": "Thôn Phú An, xã Ia Le, tỉnh Gia Lai"
        },
        {
          "id": "102",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh cá thể Võ Văn Đạt (Tạp hóa Dư Linh)",
          "Address": "253 Hùng Vương, TT.Chư Prông, H.Chư Prông, T.Gia Lai"
        },
        {
          "id": "103",
          "Province": "Tây Nguyên",
          "Company": "HỘ KINH DOANH LẠI THỊ HƯƠNG",
          "Address": "142 Hùng Vương, Xã Phú Thiện, Gia Lai"
        },
        {
          "id": "104",
          "Province": "Tây Nguyên",
          "Company": "Tạp hóa Vân Nghĩa",
          "Address": "Số 225 Nguyễn Huệ, xã Kông Chro, tỉnh Gia Lai"
        },
        {
          "id": "105",
          "Province": "Tây Nguyên",
          "Company": "Công Ty TNHH Kim Vy Mart",
          "Address": "23 Nguyễn Đình Chiểu, Phường Kon Tum, Tỉnh Quảng Ngãi"
        },
        {
          "id": "106",
          "Province": "Tây Nguyên",
          "Company": "Công Ty TNHH Hương Cường Con",
          "Address": "253 Nguyễn Văn Linh, Phường Đăk BLa, Tỉnh Quảng Ngãi"
        },
        {
          "id": "107",
          "Province": "Tây Nguyên",
          "Company": "Bùi Hữu Tùng (Tạp Hóa Hoàng Thanh)(Tạp Hóa Thảo) ",
          "Address": "Thôn 6, Xã Đăk Hà, Tỉnh Quảng Ngãi"
        },
        {
          "id": "108",
          "Province": "Tây Nguyên",
          "Company": "Trần Thị Thu Hà (Hà Vy)",
          "Address": "Thôn 1 - Đăk La, Xã Đăk Hà, Tỉnh Quảng Ngãi"
        },
        {
          "id": "109",
          "Province": "Tây Nguyên",
          "Company": "Đoàn Thị Kim Anh (Tạp Hóa Hồng Anh) ",
          "Address": "Thôn 1, Xã Đăk Tô, Tỉnh Quảng Ngãi"
        },
        {
          "id": "110",
          "Province": "Tây Nguyên",
          "Company": "Lưu Thị Xuân (Tạp Hóa Tấn Phát) ",
          "Address": "176 Trần Hưng Đạo - Tổ Dân Phố 6, Xã Bờ Y, Tỉnh Quảng Ngãi"
        },
        {
          "id": "111",
          "Province": "Tây Nguyên",
          "Company": "CÔNG TY TNHH TRUNG HIỀN BẢO LÂM",
          "Address": "Số 53 Lê Duẩn, Xã Bảo Lâm 1, Lâm Đồng"
        },
        {
          "id": "112",
          "Province": "Tây Nguyên",
          "Company": "HỘ KINH DOANH NGUYỄN THỊ BÍCH HẠNH  (TH Su Su )",
          "Address": "TDP 2, Xã Đạ Huoai, Lâm Đồng"
        },
        {
          "id": "113",
          "Province": "Tây Nguyên",
          "Company": "CÔNG TY TNHH ĐĂNG AN PHÁT LÂM ĐỒNG",
          "Address": "240C đường Trần Phú, Phường B'Lao, Lâm Đồng"
        },
        {
          "id": "114",
          "Province": "Tây Nguyên",
          "Company": "Tạp hóa Trung Hiếu",
          "Address": "694 Quốc lộ 20, Phường 3 Bảo Lộc, Lâm Đồng"
        },
        {
          "id": "115",
          "Province": "Tây Nguyên",
          "Company": "CTY TNHH MINH TUYỀN ĐÀ LẠT",
          "Address": "48B/4 , Tùng Lâm, Phường Lang Biang - Đà Lạt, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "116",
          "Province": "Tây Nguyên",
          "Company": "Hộ kinh doanh Đỗ Thị Đính ( Nguyệt Lộc)",
          "Address": "2 Trần Nhân Tông, P. Lâm Viên - Đà Lạt, Lâm Đồng"
        },
        {
          "id": "117",
          "Province": "Tây Nguyên",
          "Company": "TH Nhã Uyên",
          "Address": "Ngã Ba Sơn Hà, Xã Đinh Văn Lâm Hà, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "118",
          "Province": "Tây Nguyên",
          "Company": "Hộ Kinh Doanh Văn Tuyết",
          "Address": "Bồng Lai, Xã Hiệp Thạnh, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "119",
          "Province": "Tây Nguyên",
          "Company": "Trần Thị Bích Thuận (Chương Lợi)",
          "Address": "Quốc Lộ 20, Xã Ninh Gia, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "120",
          "Province": "Tây Nguyên",
          "Company": "Công ty TNHH HƯƠNG TUẤN - ĐÀ LẠT",
          "Address": "30/4, Huyền Trân Công Chúa , Phường Cam Ly - Đà Lạt, Tỉnh Lâm Đồng, Việt Nam"
        },
        {
          "id": "121",
          "Province": "Trung Tâm",
          "Company": "CTY TNHH MTV TM QUANG VINH",
          "Address": "87 Đường Số 9,Cư Xá Đài Ra Đa,P.Phú Lâm,Hcm"
        },
        {
          "id": "122",
          "Province": "Trung Tâm",
          "Company": "CTY TNHH MTV  TMDV ÁNH NGUYÊN",
          "Address": "103 Gia Phú, Bình Tiên, Hcm"
        },
        {
          "id": "123",
          "Province": "Trung Tâm",
          "Company": "CƯỜNG THẮNG",
          "Address": "48 Bình Tiên, Bình Tiên, Hcm"
        },
        {
          "id": "124",
          "Province": "Trung Tâm",
          "Company": "CTY THANH THÚY 2",
          "Address": "915 Lò Gốm, Bình Tây, Hcm"
        },
        {
          "id": "125",
          "Province": "Trung Tâm",
          "Company": "HKD MAI HOÀNG SANG (SANG GẠO)",
          "Address": "E12/367A2 Tập Đoàn 16, Ấp 40, Xã Hưng Long, Tp. Hồ Chí Minh"
        },
        {
          "id": "126",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH NGUYỄN THỊ HỒNG CHÂU",
          "Address": "668A/20 Ấp 36, Xã Bình Chánh, Tp Hồ Chí Minh, Việt Nam"
        },
        {
          "id": "127",
          "Province": "Trung Tâm",
          "Company": "HKD TẠP HÓA SƠN",
          "Address": "A11/13 (Đc Mới: 46) Công Nghệ Mới, Xã Tân Vĩnh Lộc, Tp. Hồ Chí Minh"
        },
        {
          "id": "128",
          "Province": "Trung Tâm",
          "Company": "HKD NGỌC TUYẾT ANH (NGỌC TUYẾT)",
          "Address": "F1/2T (Số Cũ: F1/2) Hương Lộ 80, Ấp 72, Xã Vĩnh Lộc, Tp.Hồ Chí Minh"
        },
        {
          "id": "129",
          "Province": "Trung Tâm",
          "Company": "ĐỊA ĐIỂM KINH DOANH CÔNG TY TNHH ĐẦU TƯ PHÁT TRIỂN THUẬN HIẾU",
          "Address": "75/3 Thạnh Xuân 18, P. Thới An, Tp.Hcm"
        },
        {
          "id": "130",
          "Province": "Trung Tâm",
          "Company": "HKD PHI HẢI 1903 (TH PHI HẢI)",
          "Address": "C12, Kp1 Nguyến Văn Quá, P. Đông Hưng Thuận, Tp Hồ Chí Minh"
        },
        {
          "id": "131",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH TẠP HÓA TRƯỜNG AN",
          "Address": "104 Trần Thị Năm, Trung Mỹ Tây, Tphcm"
        },
        {
          "id": "132",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH BÁCH HOÁ TỔNG HỢP THUẬN PHÁT ",
          "Address": "75, Trần Thị Bảy,Kp3, Phường Tân Thới Hiệp, Thành Phố Hồ Chí Minh"
        },
        {
          "id": "133",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH TẠP HÓA ĐỖ QUYÊN",
          "Address": "55/4B Ấp 4, Xã Đông Thạnh, Tp Hồ Chí Minh"
        },
        {
          "id": "134",
          "Province": "Trung Tâm",
          "Company": "QUANG HIẾU",
          "Address": "22/5A, Ấp Mới 1, Xã Hóc Môn, Tp. Hồ Chí Minh"
        },
        {
          "id": "135",
          "Province": "Trung Tâm",
          "Company": "THẾ HƯƠNG (HKD TÔ VĂN THẾ)",
          "Address": "39/4H, Trịnh Thị Miếng , Xã Đông Thạnh, Tp Hồ Chí Minh"
        },
        {
          "id": "136",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH BÉ THỎ",
          "Address": "40/3D Ấp Mỹ Hòa 4, Xã Xuân Thới Sơn, Tp Hồ Chí Minh"
        },
        {
          "id": "137",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH ĐẠI LÝ BIA MINH CHÁNH 1968",
          "Address": "42 Nguyễn Phúc Chu, Phường Tân Sơn, Tp. Hồ Chí Minh, Việt Nam"
        },
        {
          "id": "138",
          "Province": "Trung Tâm",
          "Company": "TẠP HÓA 28C",
          "Address": "28C Nguyễn Hiến Lê, Phường Tân Bình, Tp. Hồ Chí Minh"
        },
        {
          "id": "139",
          "Province": "Trung Tâm",
          "Company": "HKD NGUYỄN VĂN\nHOÀNG SANG (ĐẠI LÝ\nANH SANG)",
          "Address": "29/32/22E Đoàn Thị Điểm, P.\nCầu Kiệu"
        },
        {
          "id": "140",
          "Province": "Trung Tâm",
          "Company": "HKD DIỆC NGÂN 281",
          "Address": "281 Huỳnh Văn Bánh,\nPhường Phú Nhuận"
        },
        {
          "id": "141",
          "Province": "Trung Tâm",
          "Company": "LIÊU THOẠI CHÂU (TH 71)",
          "Address": "71 Phan Xích Long, Phường Minh Phụng, Tp. Hcm"
        },
        {
          "id": "142",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH CÔ MÙI (TẠP HÓA CÔ MÙI)",
          "Address": "168/1 Lê Thị Bạch Cát, Phường Phú Thọ, Tp. Hcm"
        },
        {
          "id": "143",
          "Province": "Trung Tâm",
          "Company": "DNTN HUYỀN VIỆT",
          "Address": "456/30, Cao Thắng, P. Hòa Hưng, Tp. Hồ Chí Minh"
        },
        {
          "id": "144",
          "Province": "Trung Tâm",
          "Company": "CTY TNHH MTV YẾN TUYẾT A.T.T ",
          "Address": "021 Lô F C/C Ngô Gia Tự, P. Vườn Lài, Tp Hcm (Cty: 128A/5, Nguyễn Chí Thanh, P. Vườn Lài, Tp. Hcm)"
        },
        {
          "id": "145",
          "Province": "Trung Tâm",
          "Company": "CÔ 4",
          "Address": "100E Hàm Nghi, Phường Sài Gòn, Tp.Hcm"
        },
        {
          "id": "146",
          "Province": "Trung Tâm",
          "Company": "ĐẠI LÝ NHÃ",
          "Address": "60E Trương Hán Siêu, Phường Tân Định,Tp.Hcm"
        },
        {
          "id": "147",
          "Province": "Trung Tâm",
          "Company": "ĐẠI LÝ MINH HOÀNG (CTY TNHH TM DV NHẤT MINH HOÀNG)",
          "Address": "201 Cô Giang,Phường Cầu Ông Lãnh,Tp.Hcm"
        },
        {
          "id": "148",
          "Province": "Trung Tâm",
          "Company": "TH MINH ANH",
          "Address": "287/34 Nguyễn Đình Chiểu, Phường Bàn Cờ, Tp Hồ Chí Minh"
        },
        {
          "id": "149",
          "Province": "Trung Tâm",
          "Company": "ĐẠI LÝ CƯỜNG THỊNH",
          "Address": "453/40Kc Lê Văn Sỹ, P.Nhiêu Lộc, Tp.Hcm"
        },
        {
          "id": "150",
          "Province": "Trung Tâm",
          "Company": "ĐẠI LÝ MINH",
          "Address": "31 Lê Văn Sỹ, P.Nhiêu Lộc, Tp.Hcm"
        },
        {
          "id": "151",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY 155(ĐL 401)",
          "Address": "155 Đặng Thuỳ Trăm,Phường Bình Lợi Trung,Tp Hcm"
        },
        {
          "id": "152",
          "Province": "Trung Tâm",
          "Company": "HKD TẠP HOÁ NAM(ĐL NAM)",
          "Address": "73 Vũ Tùng,Phường Gia Định"
        },
        {
          "id": "153",
          "Province": "Trung Tâm",
          "Company": "ĐL NĂM HÀ",
          "Address": "480/1 Bình Quới, Phường Bình Quới, Tp Hcm"
        },
        {
          "id": "154",
          "Province": "Trung Tâm",
          "Company": "ĐL OANH PHÁT",
          "Address": "212 Nguyễn Văn Khạ,Xã Tân An Hội,Tphcm"
        },
        {
          "id": "155",
          "Province": "Trung Tâm",
          "Company": "ĐL NGÂN TIÊN",
          "Address": "414 Tỉnh Lộ 2,Xã Củ Chi,Tphcm"
        },
        {
          "id": "156",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH TM DV BÁT VẬN THIÊN",
          "Address": "A8, Dương Quảng Hàm, Phường An Nhơn, Tp. Hồ Chí Minh"
        },
        {
          "id": "157",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH TM XNK ĐỖ QUYÊN",
          "Address": "386,  Lê Văn Thọ, Phường An Hội Đông, Tp. Hồ Chí Minh"
        },
        {
          "id": "158",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH THẢO TÂN TD",
          "Address": "31, Đường Số 14, Phường An Nhơn, Tp. Hồ Chí Minh"
        },
        {
          "id": "159",
          "Province": "Trung Tâm",
          "Company": "HKD BIA NƯỚC NGỌT NHẬT NGUYỆT",
          "Address": "36 Đường 29, P Cát Lái, Tp Hồ Chí Minh"
        },
        {
          "id": "160",
          "Province": "Trung Tâm",
          "Company": "CỬA HÀNG ANH VŨ",
          "Address": "720 Nguyễn Duy Trinh, P Bình Trưng, Tp Hồ Chí Minh"
        },
        {
          "id": "161",
          "Province": "Trung Tâm",
          "Company": "HKD HỒNG YẾN",
          "Address": "36 Lương Định Của, P An Khánh, Tp Hồ Chí Minh"
        },
        {
          "id": "162",
          "Province": "Trung Tâm",
          "Company": "HKD GIANG QUANG MINH (TH 53)",
          "Address": "53 Hồ Văn Tư,Phường Thủ Đức,Tphcm"
        },
        {
          "id": "163",
          "Province": "Trung Tâm",
          "Company": "HKD HUỲNH THỊ DIỄM  ( ĐL BIA NƯỚC NGỌT)",
          "Address": "172A Hiệp Bình,P. Hiệp Bình ,  Tp. Hồ Chí Minh"
        },
        {
          "id": "164",
          "Province": "Trung Tâm",
          "Company": "HKD THÚY ANH ( THÚY ANH) ",
          "Address": "249 Kha Vạn Cân, P. Hiệp Bình , Tp. Hồ Chí Minh"
        },
        {
          "id": "165",
          "Province": "Trung Tâm",
          "Company": "HKD TẠP HÓA 1 (TẠP HÓA CHỊ VÂN)",
          "Address": "146 Hoàng Cầm, P. Linh Xuân, Tp. Hồ Chí Minh"
        },
        {
          "id": "166",
          "Province": "Trung Tâm",
          "Company": "Đại Lý Tư Dũng",
          "Address": "689 Lê Văn Việt, P. Tân Phú, TP.Hồ Chí Minh"
        },
        {
          "id": "167",
          "Province": "Trung Tâm",
          "Company": "THẾ HẢI",
          "Address": "140, Ấp Bình Phước, Xã Bình Khánh, Tp Hồ Chí Minh"
        },
        {
          "id": "168",
          "Province": "Trung Tâm",
          "Company": "HKD NAM ANH",
          "Address": "Số 291/3, Đường Gióng Ao, Tổ 2, Kp Giòng Ao, Xã Cần Giờ, Tp. Hồ Chí Minh"
        },
        {
          "id": "169",
          "Province": "Trung Tâm",
          "Company": "ĐL 244 ( HKD HAI BỐN BỐN )",
          "Address": "244 Tôn Đản, Phường Khánh Hội, Tp. Hcm"
        },
        {
          "id": "170",
          "Province": "Trung Tâm",
          "Company": "ANH ĐÀO",
          "Address": "209/76A Tôn Thất Thuyết, Phường Vĩnh Hội, Tp.Hcm"
        },
        {
          "id": "171",
          "Province": "Trung Tâm",
          "Company": "THÀNH LỢI",
          "Address": "126, Lê Văn Lương, Xã Nhà Bè,\n Thành Phố Hồ Chí Minh, Việt Nam"
        },
        {
          "id": "172",
          "Province": "Trung Tâm",
          "Company": "HKD VẠN LỘC",
          "Address": "1916 (Số Cũ: 46/9) Đường Huỳnh Tấn Phát, Xã Nhà Bè, Tp.Hcm"
        },
        {
          "id": "173",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH THẢO TẤN PHÁT",
          "Address": "981, Nguyễn Trãi, Phường Chợ Lớn, Tp. Hồ Chí Minh"
        },
        {
          "id": "174",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH TM MINH KÝ",
          "Address": "004, Lô C Mạc Thiên Tích, Phường An Đông, Tp. Hồ Chí Minh"
        },
        {
          "id": "175",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ TỔNG HỢP HIẾU THẢO.",
          "Address": "2695/14/10/5. Phạm Thế Hiển, Phường Bình Đông, Thành Phố Hồ Chí Minh, Việt Nam."
        },
        {
          "id": "176",
          "Province": "Trung Tâm",
          "Company": "CÔNG TY TNHH THƯƠNG MẠI BIA VÀ NƯỚC GIẢI KHÁT TIẾN ĐẠT.",
          "Address": "Số 10. Đường Ba Đình, Phường Chánh Hưng, Thành Phố Hồ Chí Minh, Việt Nam."
        },
        {
          "id": "177",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH NƯỚC GIẢI KHÁT 2278.",
          "Address": "Số 2278. Phạm Thế Hiển, Phường Bình Đông, Thành Phố Hồ Chí Minh, Việt Nam."
        },
        {
          "id": "178",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH TRẦN THỊ THU THẢO ( BÁCH HÓA CÔ BA ).",
          "Address": "180. Bùi Minh Trực, Phường Bình Đông, Thành Phố Hồ Chí Minh, Việt Nam."
        },
        {
          "id": "179",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH ĐẠI LÝ BIA ĐIỂM 12",
          "Address": "Số 22. Đường 3441, Phường Bình Đông, Thành Phố Hồ Chí Minh, Việt Nam."
        },
        {
          "id": "180",
          "Province": "Trung Tâm",
          "Company": "HỘ KINH DOANH TẠP HÓA TÁM HUY.",
          "Address": "76/29/1 Đường 74. Phường Phú Định, Thành Phố Hồ Chí Minh, Việt Nam."
        },
        {
          "id": "181",
          "Province": "Miền Đông",
          "Company": "An Tâm",
          "Address": "24 Phan Bội Châu Thủ Dầu Một TP. Hồ Chí Minh"
        },
        {
          "id": "182",
          "Province": "Miền Đông",
          "Company": "TH 225",
          "Address": "225 Yersin Thủ Dầu Một TP. Hồ Chí Minh"
        },
        {
          "id": "183",
          "Province": "Miền Đông",
          "Company": "TH 162",
          "Address": "168 CMT8 Thủ Dầu Một TP. Hồ Chí Minh"
        },
        {
          "id": "184",
          "Province": "Miền Đông",
          "Company": "Thành Đạt",
          "Address": "6 Lào Cai Thủ Dầu Một TP. Hồ Chí Minh"
        },
        {
          "id": "185",
          "Province": "Miền Đông",
          "Company": "Sang Cầu Trắng ",
          "Address": "1059 Lê Hồng Phong Thủ Dầu Một TP. Hồ Chí Minh"
        },
        {
          "id": "186",
          "Province": "Miền Đông",
          "Company": "Phú Lộc",
          "Address": " đường DJ10 Bến Cát TP. Hồ Chí Minh"
        },
        {
          "id": "187",
          "Province": "Miền Đông",
          "Company": "Tám Đoạt",
          "Address": " DT741 Tân Định TP. Hồ Chí Minh"
        },
        {
          "id": "188",
          "Province": "Miền Đông",
          "Company": "Chú Huệ",
          "Address": " DT748 Long Nguyên TP. Hồ Chí Minh"
        },
        {
          "id": "189",
          "Province": "Miền Đông",
          "Company": "Hai Tiến",
          "Address": " D9 Bến Cát TP. Hồ Chí Minh"
        },
        {
          "id": "190",
          "Province": "Miền Đông",
          "Company": "Út Oanh",
          "Address": "867 Nguyễn Chí Thanh Phú An TP. Hồ Chí Minh"
        },
        {
          "id": "191",
          "Province": "Miền Đông",
          "Company": "Vân Trinh",
          "Address": "294 Trần Quốc Toản Tam Hiệp Đồng Nai"
        },
        {
          "id": "192",
          "Province": "Miền Đông",
          "Company": "Phi Phi",
          "Address": "0 Hoàng Tam Kỳ Long Bình Đồng Nai"
        },
        {
          "id": "193",
          "Province": "Miền Đông",
          "Company": "Chị Bến",
          "Address": "0 Khu Phố 1 Long Bình Đồng Nai"
        },
        {
          "id": "194",
          "Province": "Miền Đông",
          "Company": "Sơn Hà",
          "Address": "0 Tây Lạc Bình Minh Đồng Nai"
        },
        {
          "id": "195",
          "Province": "Miền Đông",
          "Company": "La Thành",
          "Address": "0 Bùi Hữu Nghìa Biên Hòa Đồng Nai"
        },
        {
          "id": "196",
          "Province": "Miền Đông",
          "Company": "Tấn Phát",
          "Address": "52C Quốc Lộ 1K Biên Hòa Đồng Nai"
        },
        {
          "id": "197",
          "Province": "Miền Đông",
          "Company": "Ngọc Loan",
          "Address": " Tổ 12, Long Đức 3 Tam Phước Đồng Nai"
        },
        {
          "id": "198",
          "Province": "Miền Đông",
          "Company": "Sơn Phương Thủy",
          "Address": " hùng vương Phước An Đồng Nai"
        },
        {
          "id": "199",
          "Province": "Miền Đông",
          "Company": "Gas Thời",
          "Address": " Ấp Bình Lâm Xã Long Thành Đồng Nai"
        },
        {
          "id": "200",
          "Province": "Miền Đông",
          "Company": "Lưu Thu",
          "Address": " Ấp Chợ Xã Nhơn Trạch Đồng Nai"
        },
        {
          "id": "201",
          "Province": "Miền Đông",
          "Company": "Thủy An",
          "Address": " Ấp 2 Xã Xuân Hưng Đồng Nai"
        },
        {
          "id": "202",
          "Province": "Miền Đông",
          "Company": "Thúy Nga",
          "Address": " Núi Đỏ P. Bàu Sen Đồng Nai"
        },
        {
          "id": "203",
          "Province": "Miền Đông",
          "Company": "Oanh oanh",
          "Address": " Ấp Đức Huy Xã Gia Tân 2 Đồng Nai"
        },
        {
          "id": "204",
          "Province": "Miền Đông",
          "Company": "Nguyên",
          "Address": " Hiệp Tâm 2 TT. Định Quán Đồng Nai"
        },
        {
          "id": "205",
          "Province": "Miền Đông",
          "Company": "Trang",
          "Address": " Khu Phố Trần Hưng Đạo Dầu Giây Đồng Nai"
        },
        {
          "id": "206",
          "Province": "Miền Đông",
          "Company": "Công Ty TNHH TMDV Thân Gia",
          "Address": "70/2C Trần Xuân Độ Vũng Tàu HCM"
        },
        {
          "id": "207",
          "Province": "Miền Đông",
          "Company": "Chị Hương ",
          "Address": "207 Võ Thị Sáu Vũng Tàu HCM"
        },
        {
          "id": "208",
          "Province": "Miền Đông",
          "Company": "CHTC 828",
          "Address": "828 30/4 Phước Thắng HCM"
        },
        {
          "id": "209",
          "Province": "Miền Đông",
          "Company": "Quyết Thắng",
          "Address": "Tổ 21 KP Mỹ Thạnh P. Phú Mỹ HCM"
        },
        {
          "id": "210",
          "Province": "Miền Đông",
          "Company": "Đại Lý A Sơn",
          "Address": "Tổ 3 Ấp Lộc Hòa X. Bình Giã HCM"
        },
        {
          "id": "211",
          "Province": "Miền Đông",
          "Company": "Thanh Kiều",
          "Address": "75 Ô 3 KP Thanh Long X. Đất Đỏ HCM"
        },
        {
          "id": "212",
          "Province": "Miền Đông",
          "Company": "Tân Long",
          "Address": "Tổ 14 KP Mỹ Tân P. Phú Mỹ HCM"
        },
        {
          "id": "213",
          "Province": "Miền Đông",
          "Company": "Dê 22",
          "Address": "Tổ 1 KP. Tân Hạnh P. Phú Mỹ HCM"
        },
        {
          "id": "214",
          "Province": "Miền Đông",
          "Company": "Thiên Hương ",
          "Address": " Điện Biên Phủ, Tổ 5, Khu Phố 2 P. Bà Rịa HCM"
        },
        {
          "id": "215",
          "Province": "Miền Đông",
          "Company": "Quán Dũng",
          "Address": "80C1 Trương Công Định  P. Vũng Tàu HCM"
        },
        {
          "id": "216",
          "Province": "Miền Đông",
          "Company": "Quán 45",
          "Address": "45 Nguyễn Tri Phương P. Tam Thắng HCM"
        },
        {
          "id": "217",
          "Province": "Miền Đông",
          "Company": "Bích Phượng",
          "Address": "166 Nguyễn Thiện Thuật P. Rạch Dừa HCM"
        },
        {
          "id": "218",
          "Province": "Miền Đông",
          "Company": "Thanh Hiền ",
          "Address": " Ql13, Tổ 6 Minh Hưng Đồng Nai"
        },
        {
          "id": "219",
          "Province": "Miền Đông",
          "Company": "Ngọc Sáng",
          "Address": " Ql13, Kp 1  Bình Long Đồng Nai"
        },
        {
          "id": "220",
          "Province": "Miền Đông",
          "Company": "Thanh Thảo ",
          "Address": " Ql13 Lộc Tấn Đồng Nai "
        },
        {
          "id": "221",
          "Province": "Miền Đông",
          "Company": "Đăng Khoa ( Cty Song Hương)",
          "Address": " KP Gia Huỳnh P.Trảng Bàng Tây Ninh"
        },
        {
          "id": "222",
          "Province": "Miền Đông",
          "Company": "Minh Sang (Cty Huy Minh Sang)",
          "Address": " Suối Sâu An Tịnh Tây Ninh"
        },
        {
          "id": "223",
          "Province": "Miền Đông",
          "Company": "Bích Loaan",
          "Address": " An Quới Trảng Bàng Tây Ninh"
        },
        {
          "id": "224",
          "Province": "Miền Đông",
          "Company": "Thu Thảo",
          "Address": " Phước Hòa Dương Minh Châu Tây Ninh"
        },
        {
          "id": "225",
          "Province": "Miền Đông",
          "Company": "Chị My",
          "Address": " QL 22B Trà Vong Tây Ninh"
        },
        {
          "id": "226",
          "Province": "Miền Đông",
          "Company": "Anh Sâm (Thúy Vy)",
          "Address": " Ninh Trung Bình Minh Tây Ninh"
        },
        {
          "id": "227",
          "Province": "Miền Đông",
          "Company": "Tố Như",
          "Address": "46096  Ngô Quyền Long Hoa Tây Ninh"
        },
        {
          "id": "228",
          "Province": "Miền Đông",
          "Company": "Phúc Thịnh",
          "Address": "93B Phạm Hùng Hòa Thành Tây Ninh"
        },
        {
          "id": "229",
          "Province": "Miền Đông",
          "Company": "Hùng Hà",
          "Address": " Thủ Khoa Huân Thuân Giao TP Hồ Chí Minh"
        },
        {
          "id": "230",
          "Province": "Miền Đông",
          "Company": "Khánh Ngọc",
          "Address": " KDC Thuận Giao, Thuân Giao TP Hồ Chí Minh"
        },
        {
          "id": "231",
          "Province": "Miền Đông",
          "Company": "CT TNHH TIẾN PHÚ QUÝ",
          "Address": " KDC Thuận Giao, Thuân Giao TP Hồ Chí Minh"
        },
        {
          "id": "232",
          "Province": "Miền Đông",
          "Company": "Chí Linh",
          "Address": "KP Uyên Hưng 7 ĐT 747B Tân Uyên TP Hồ Chí Minh"
        },
        {
          "id": "233",
          "Province": "Miền Đông",
          "Company": "Cẩm Vân",
          "Address": "93B PHạm Ngũ Lão Dĩ An TP Hồ Chí Minh"
        },
        {
          "id": "234",
          "Province": "Miền Đông",
          "Company": "Việt Anh",
          "Address": "30D D23 Việt Sing P. An Phú TP Hồ Chí Minh"
        },
        {
          "id": "235",
          "Province": "Miền Đông",
          "Company": "Minh An",
          "Address": "500/10 Đỗ Tấn Phong Tân Đông Hiệp TP Hồ Chí Minh"
        },
        {
          "id": "236",
          "Province": "Miền Đông",
          "Company": "Cô Diễm",
          "Address": " Chợ Long Tân X. Long Hà  Đồng Nai"
        },
        {
          "id": "237",
          "Province": "Miền Đông",
          "Company": "Ân Huệ",
          "Address": "697 Phú Riềng Đỏ  P. Bình Phước  Đồng Nai"
        },
        {
          "id": "238",
          "Province": "Miền Đông",
          "Company": "Hồng Hoàn",
          "Address": "119 Hùng Vương Bù Đăng Đồng Nai"
        },
        {
          "id": "239",
          "Province": "Miền Đông",
          "Company": "Thảo My",
          "Address": " N1, Bàu Ké Đồng Phú  Đồng Nai"
        },
        {
          "id": "240",
          "Province": "Miền Đông",
          "Company": "Tuân Ngọc 2",
          "Address": " Thanh Sơn Thiện Hưng Đồng Nai "
        },
        {
          "id": "241",
          "Province": "Sông Hậu",
          "Company": "PHƯƠNG UYÊN ",
          "Address": "Khu vực Qui Thạnh I, Phường Thuận Hưng, TP Cần Thơ"
        },
        {
          "id": "242",
          "Province": "Sông Hậu",
          "Company": "Minh Trang",
          "Address": "Số 113, KV 11, P Ô Môn, TP Cần Thơ"
        },
        {
          "id": "243",
          "Province": "Sông Hậu",
          "Company": "HKD MINH NHỰT 3",
          "Address": "A39, Đường số 9, KDC 586, P. Hưng Phú, TP. Cần Thơ "
        },
        {
          "id": "244",
          "Province": "Sông Hậu",
          "Company": "HKD BIA NƯỚC ĐÁ NGÂN",
          "Address": "ĐƯỜNG BÙI QUANG TRINH, KDC 586, P. HƯNG PHÚ, TP CT"
        },
        {
          "id": "245",
          "Province": "Sông Hậu",
          "Company": "CÔNG TY TNHH TMDV NÔNG NGHIỆP QUỐC TẾ CẦN THƠ",
          "Address": "58 Trương Vĩnh Nguyên, KV Thạnh Mỹ, P. Cái Răng, TP. Cần Thơ"
        },
        {
          "id": "246",
          "Province": "Sông Hậu",
          "Company": "MẾN LINH",
          "Address": "Khu Tái Định Cư, Ấp Thị Tứ Vàm Xáng,X Nhơn Nghĩa,Tp Cần Thơ"
        },
        {
          "id": "247",
          "Province": "Sông Hậu",
          "Company": "HKD BÙI CÔNG QUÍ (KHÁNH)",
          "Address": "Ấp Nhơn Khánh, Xã Nhơn Ái, TP Cần Thơ"
        },
        {
          "id": "248",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH NGUYỄN VĂN BẰNG",
          "Address": "13A, Nguyễn Đệ, Phường Cái Khế, TP Cần Thơ"
        },
        {
          "id": "249",
          "Province": "Sông Hậu",
          "Company": "CÔNG TY TNHH BIA QUỐC HƯNG",
          "Address": "Số 253 Trần Hưng Đạo, KV. 3, P. Vị Tân, TP. Cần Thơ"
        },
        {
          "id": "250",
          "Province": "Sông Hậu",
          "Company": "CÔNG TY TNHH ĐẦU TƯ THƯƠNG MẠI HẢI ĐỊNH",
          "Address": "Số 546 đường 30/4 ấp 1, Xã Vị Thủy, TP Cần Thơ"
        },
        {
          "id": "251",
          "Province": "Sông Hậu",
          "Company": "CÔNG TY TNHH MTV ÚT TRƯỜNG",
          "Address": "ấp Thị Trấn, Xã Châu Thành, TP Cần Thơ"
        },
        {
          "id": "252",
          "Province": "Sông Hậu",
          "Company": "Công ty TNHH MTV Vận Tải Nguyễn Xái",
          "Address": "Ấp Tân Bình, P. Long Phú 1, TP. Cần Thơ"
        },
        {
          "id": "253",
          "Province": "Sông Hậu",
          "Company": "Công Ty TNHH Distribution Kim Việt",
          "Address": "Số 68, Đường Nam Sông Hậu, Phường Vĩnh Châu, TP. Cần Thơ"
        },
        {
          "id": "254",
          "Province": "Sông Hậu",
          "Company": "Cty TNHH Quang Chánh",
          "Address": "Số 72, Mạc Đỉnh Chi, Phường Phú Lợi, TP. Cần Thơ "
        },
        {
          "id": "255",
          "Province": "Sông Hậu",
          "Company": "Công Ty TNHH Vinh Phú ST",
          "Address": "Số 143 đường Phạm Hùng, Phường Sóc Trăng, TP. Cần Thơ"
        },
        {
          "id": "256",
          "Province": "Sông Hậu",
          "Company": "Cty TNHH Rượu Bia NGK Ngọc Lư",
          "Address": "Số 13, Tỉnh Lộ 934, Ấp Hòa Mỹ, Phường Mỹ Xuyên, Tp. Cần Thơ"
        },
        {
          "id": "257",
          "Province": "Sông Hậu",
          "Company": "Công Ty TNHH MTV Hoàng Chư",
          "Address": "Ấp Cầu Đỏ, Xã Vĩnh Lộc,  Tỉnh Cà Mau "
        },
        {
          "id": "258",
          "Province": "Sông Hậu",
          "Company": "Cty TNHH Rượu Bia NGK Ngọc Lư",
          "Address": "Số 236 đường 23/08, Khóm 1, Phường  Bạc Liêu, Tỉnh Cà Mau"
        },
        {
          "id": "259",
          "Province": "Sông Hậu",
          "Company": "DNTN HẢI TRANG",
          "Address": "Số 16, Đường Châu Văn Đặng, Phường Bạc Liêu,Tỉnh Cà Mau "
        },
        {
          "id": "260",
          "Province": "Sông Hậu",
          "Company": "CÔNG TY TNHH  TM TIỀN THỦY",
          "Address": "Số 999, đường 23/8, khóm 3, Phường Bạc Liêu,Tỉnh Cà Mau"
        },
        {
          "id": "261",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH MTV ĐỔNG CÔNG DANH",
          "Address": "Thửa đất số 0331, Tờ bản đồ số 5B, Ấp Đức An, xã Lương Thế Trân, tỉnh Cà Mau"
        },
        {
          "id": "262",
          "Province": "Sông Hậu",
          "Company": "HKD Mỹ Anh",
          "Address": "Số 153, đường Nguyễn Công Trứ, khóm 1, Phường Lý Văn Lâm, tỉnh Cà Mau"
        },
        {
          "id": "263",
          "Province": "Sông Hậu",
          "Company": "Công Ty TNHH MTV Tư Thơ",
          "Address": "Tờ bản đồ 934, thửa số 4, Ấp Hưng Thành, xã Lương Thế Trân, tỉnh Cà Mau"
        },
        {
          "id": "264",
          "Province": "Sông Hậu",
          "Company": "Huỳnh Văn Đáp (Huỳnh Đáp)",
          "Address": "Ấp Lộ Xe, xã Lương Thế Trân, tỉnh Cà Mau"
        },
        {
          "id": "265",
          "Province": "Sông Hậu",
          "Company": "HKD Trần Hoàng Văn (Năm Đẹp)",
          "Address": "Ấp Lộ Xe, xã Lương Thế Trân, tỉnh Cà Mau"
        },
        {
          "id": "266",
          "Province": "Sông Hậu",
          "Company": "HKD Dương Tuyền (Dương Tuyền)",
          "Address": "Ấp Sở Tại, Xã Lương Thế Trân, Tỉnh Cà Mau"
        },
        {
          "id": "267",
          "Province": "Sông Hậu",
          "Company": "HKD Huỳnh Nghĩa",
          "Address": "Ấp Cái Nai, Xã Năm Căn, Tỉnh Cà Mau"
        },
        {
          "id": "268",
          "Province": "Sông Hậu",
          "Company": "HKD Cafe Sinh Thái Uyên (Phương Nguyên 2)",
          "Address": "Ấp Kinh Ba, Xã Phan Ngọc Hiển, Tỉnh Cà Mau"
        },
        {
          "id": "269",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH MTV TM DV THÙY DƯƠNG",
          "Address": "302/26 Trần Hưng Đạo, Khóm Mỹ Lộc, Phường Long Xuyên, Tỉnh An Giang"
        },
        {
          "id": "270",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH PHƯỚC QUANG CHỢ MỚI",
          "Address": "Tổ 16, Ấp Thị, Xã Cù Lao Giêng, Tỉnh An Giang"
        },
        {
          "id": "271",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH THÁI PHÁT ĐẠT TỊNH BIÊN",
          "Address": "KDC Sao Mai, Khóm Xuân Biên, Phường Tịnh Biên, Tỉnh An Giang"
        },
        {
          "id": "272",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH MTV SIÊU THỊ BIA",
          "Address": "Tổ 6, Ấp Tà On, Xã Tri Tôn, Tỉnh An Giang"
        },
        {
          "id": "273",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH MTV TMDV HỒNG TRỌNG NGHĨA",
          "Address": "Số 113, Triệu Quang Phục, Phường Long Xuyên, Tỉnh An Giang"
        },
        {
          "id": "274",
          "Province": "Sông Hậu",
          "Company": " CTY TNHH DUY MỸ PHÚ QUỐC",
          "Address": "Tổ 2, Đường Cách mạng tháng tám, Kp10, Đặc Khu Phú Quốc< An Giang"
        },
        {
          "id": "275",
          "Province": "Sông Hậu",
          "Company": "CTY TNHH MTV TM DV CHIÊU HƯNG PHÁT",
          "Address": "Thửa 422, đường Tỉnh Lộ 28, tổ 2, khu phố 2, Phường Hà Tiên, Tỉnh An Giang"
        },
        {
          "id": "276",
          "Province": "Sông Hậu",
          "Company": "CÔNG TY TNHH MỘT THÀNH VIÊN HUYỀN ĐINH",
          "Address": "Lô 08-05, Lộ Liên Hương, khu tái định cư, phường Rạch Giá, tỉnh An Giang"
        },
        {
          "id": "277",
          "Province": "Sông Hậu",
          "Company": "Anh Thư (HKD Trần Trúc Ly)",
          "Address": "120 Nguyễn Văn Tố, Phường Rạch Giá, tỉnh An Giang"
        },
        {
          "id": "278",
          "Province": "Sông Hậu",
          "Company": "Nguyễn Ngân (HKD Xuân Thực)",
          "Address": "13/24 Ngô Văn Sở, Phường Rạch Giá, tỉnh An Giang"
        },
        {
          "id": "279",
          "Province": "Sông Hậu",
          "Company": "HKD Đại Lý Tân Huy Hoàng",
          "Address": "927 QL 80 ấp Phước Hòa, xã Thạnh Lộc, tỉnh An Giang"
        },
        {
          "id": "280",
          "Province": "Sông Hậu",
          "Company": "HKD Tạp Hóa Duyên",
          "Address": "120D Thiên Hộ Dương, Phường Rạch Giá, tỉnh An Giang"
        }
      ],

      lstShow: [],

      columns: [
        { title: "Khu vực", dataIndex: "Province",width: 90 },
        { title: "Tên điểm", dataIndex: "Company",width: 210 },
        { title: "Địa chỉ", dataIndex: "Address" },
      ],
    }
  },

  created() {
    this.lstShow = this.lstData
  },

  watch: {
    searchText(val) {
      const keyword = this.normalize(val)

      this.lstShow = this.lstData.filter((x) =>
        Object.values(x).some((v) =>
          this.normalize(String(v)).includes(keyword)
        )
      )
    },
  },

  methods: {
    // 🔥 Bỏ dấu + chuẩn hóa
    normalize(str) {
      return str
        .toLowerCase()
        .normalize("NFD") // tách dấu
        .replace(/[\u0300-\u036f]/g, "") // xóa dấu
        .replace(/đ/g, "d")
        .replace(/Đ/g, "d")
    },
  },
}
</script>